// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"m3-z","colorTextValue":"n3-z","swatches":"o3-z","collapseLink":"p3-z","isCollapsed":"q3-z","dropdown":"r3-z","disabled":"s3-z"};